<template>
  <long-query-layout
    resource-name="monkey-d"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :result-fetch-url.sync="resultTable.url"
    :columns.sync="resultTable.columns"
    :group-headers.sync="resultTable.groupHeaders"
    :active-tab.sync="activeTab"
    :customers.sync="customerCollection"
    :excel-properties-handler="excelPropertiesHandler.bind(this)"
    :convert-menu-default-query-filter="convertMenuDefaultQueryFilter"
    @result-area-size-change="updateTableSize"
  >
    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 期間 -->
      <query-filter-element id="term" title="期間" contentWidth="medium">
        <filter-term-select v-bind.sync="queryFilter.term" />
      </query-filter-element>

      <!-- 商品分類 -->
      <query-filter-element id="item" title="商品分類">
        <gl-select-company :company.sync="queryFilter.item.company" />
        <div>
          <md-radio v-model="queryFilter.item.selectMode" value="category">
            分類
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
          <md-radio v-model="queryFilter.item.selectMode" value="item">
            商品
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
        </div>
        <filter-item-category
          v-if="queryFilter.item.selectMode === 'category'"
          v-bind.sync="queryFilter.item"
        />
        <filter-item
          v-if="queryFilter.item.selectMode === 'item'"
          v-bind.sync="queryFilter.item"
        />
      </query-filter-element>

      <!-- 店舗 -->
      <query-filter-element id="store" title="店舗" contentWidth="medium">
        <filter-store v-bind.sync="queryFilter.store" />
      </query-filter-element>

      <!-- 顧客グループ -->
      <query-filter-element id="customer" title="顧客グループ">
        <filter-customer v-bind.sync="queryFilter.customer" />
      </query-filter-element>

      <!-- オプション -->
      <query-filter-element id="option" title="オプション">
        <filter-option
          v-bind.sync="queryFilter.option"
          :visible-evaluations="[
            'amount',
            'qty',
            'receipt_count',
            'amount_per_receipt',
            'qty_per_receipt',
            'amount_per_qty',
          ]"
        />
        <filter-option-monkey-d v-bind.sync="queryFilter.option" />
      </query-filter-element>

      <!-- 顧客ファイル属性アップロード中通知 -->
      <md-dialog
        :md-active.sync="uploadingCustomerAttributeFile"
        :md-close-on-esc="false"
        :md-click-outside-to-close="false"
      >
        <md-dialog-content>
          <div style="display:flex;align-items:center">
            <spinner :diameter="30" />
            <span style="margin-left:var(--spacing-medium)">
              顧客属性ファイルをアップロードしています...
            </span>
          </div>
        </md-dialog-content>
      </md-dialog>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <gl-table ref="myTable" v-bind="resultTable" />
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件サマリ
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTermSelect from '@/components/FilterTermSelect.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'
import FilterItem from '@/components/FilterItem2.vue'
import FilterStore from '@/components/FilterStore.vue'
import FilterCustomer from '@/components/FilterCustomer.vue'
import FilterOption from '@/components/FilterOption.vue'
import FilterOptionMonkeyD from '@/components/FilterOptionMonkeyD.vue'
// 分析条件モデル
import termSelect from '@/queryfilter/termSelect'
import item from '@/queryfilter/item2'
import store from '@/queryfilter/store'
import customer from '@/queryfilter/customer'
// 分析結果
import GlTable from '@/components/GlTable.vue'
import Spinner from '@/components/Spinner.vue'
let hold = false

export default {
  components: {
    QueryFilterElement,
    FilterTermSelect,
    FilterItem,
    FilterItemCategory,
    FilterStore,
    FilterCustomer,
    FilterOption,
    FilterOptionMonkeyD,
    LongQueryLayout,
    GlTable,
    Spinner,
  },
  data() {
    return {
      /**
       * 表示タブ（分析条件、分析結果）
       *
       * 表示タブをプログラム側から切り替えたい場合をこれを使います。
       */
      activeTab: undefined,
      /**
       * 分析条件
       */
      queryFilter: {
        term: { order: 1, summaryKey: 'termSelect', ...termSelect.get() },
        item: { order: 2, summaryKey: 'itemGroup', ...item.get() },
        store: { order: 3, ...store.get() },
        customer: { order: 4, ...customer.get() },
        option: {
          order: 5,
          evaluations: [
            'amount',
            'qty',
            'receipt_count',
            'amount_per_receipt',
            'qty_per_receipt',
            'amount_per_qty',
          ],
          errors: [],
          visibleCustomerSegments: [],
          userCustomerAttributeSelection: 'not',
          inputName: '',
          file: null,
          tableId: '',
        },
      },
      /**
       * 分析結果
       */
      resultTable: {
        columns: undefined,
        groupHeaders: undefined,
        sortColumnName: 'customer_code',
        sortOrder: 'asc',
        url: undefined,
        width: 0,
        height: 0,
        customFormatter: {
          linkify: (rowData, cell, value, colName) => {
            cell.classList.add('customer-collection-cell')
            cell.setAttribute(
              'data-customer-collection',
              rowData.customer_filter[colName],
            )

            const toggle = e => {
              if (!this.resultTable.columns) {
                throw new Error('Column not found')
              }
              // hit the column
              const col = this.resultTable.columns.find(
                c => c.colName === colName,
              )

              const id = e.target.getAttribute('data-customer-collection')
              const text = `${rowData.store_name} - ${col.headerText}`
              const customer = { id, text }

              this.$emit('toggle-customer-collection', customer)
            }

            cell.addEventListener('mousedown', e => {
              hold = true
              document.body.classList.add('no-select')
              toggle(e)
            })
            cell.addEventListener('mouseup', () => {
              hold = false
              document.body.classList.remove('no-select')
            })

            cell.addEventListener('mouseenter', e => {
              // console.log('hold', hold)
              if (!hold) {
                return
              }
              toggle(e)
            })
          },
        },
      },
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: async queryFilter => ({
        term: termSelect.mapToApiPayload(queryFilter.term),
        item: item.mapToApiPayload(queryFilter.item),
        store: store.mapToApiPayload(queryFilter.store),
        customer: customer.mapToApiPayload(queryFilter.customer),
        option: {
          evaluations: queryFilter.option.evaluations,
          userCustomerAttributeSelection:
            queryFilter.option.userCustomerAttributeSelection,
          inputName: queryFilter.option.inputName,
          tableId:
            queryFilter.option.userCustomerAttributeSelection === 'upload'
              ? await this.uploadCustomerAttributeFile()
              : queryFilter.option.tableId,
        },
      }),
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       *
       * 渡される分析条件はこの画面のものとは限らないので、"可能な限り"復元する。
       */
      applyQueryFilter: queryFilter => {
        termSelect.applyPayload(this.queryFilter.term, queryFilter.term)
        const p = item.applyPayload(this.queryFilter.item, queryFilter.item)
        store.applyPayload(this.queryFilter.store, queryFilter.store)
        customer.applyPayload(this.queryFilter.customer, queryFilter.customer)
        this.queryFilter.option.evaluations = queryFilter.option.evaluations
        this.queryFilter.option.userCustomerAttributeSelection =
          queryFilter.option.userCustomerAttributeSelection || 'not'
        this.queryFilter.option.inputName = queryFilter.option.inputName
        this.queryFilter.option.tableId = queryFilter.option.tableId

        return [p]
      },
      /**
       * 顧客コレクション
       */
      customerCollection: [],
      /**
       * Excel出力のパラメータ生成
       */
      excelPropertiesHandler() {
        const { name, order } = this.$refs.myTable.getCurrentSort()
        return {
          sortColumnName: name,
          sortOrder: order,
        }
      },
      /**
       * 顧客属性ファイルのアップロード中フラグ
       */
      uploadingCustomerAttributeFile: false,
    }
  },
  methods: {
    /**
     * 結果表示テーブルのサイズを更新する
     */
    updateTableSize(size) {
      this.resultTable.width = size.width
      this.resultTable.height = size.height
    },
    /**
     * 顧客属性ファイルアップロード
     */
    async uploadCustomerAttributeFile() {
      this.uploadingCustomerAttributeFile = true
      const id = await this.$repositories
        .get('userCustomerAttribute')
        .upload(this.queryFilter.option.file)
      this.uploadingCustomerAttributeFile = false
      return id
    },
    // デフォルトQueryFilterの変換処理
    // 商品グループは一時的なものなのでメニューのデフォルト条件
    // としては保持しない。
    convertMenuDefaultQueryFilter(queryFilter) {
      queryFilter.item.itemGroupId = undefined
      return queryFilter
    },
  },
}
</script>
